import { format } from "date-fns";
import { type FunctionComponent } from "react";

import { GameType } from "scmp-app/components/games/types";

import { Cell, Container, Content, CrosswordName, GifImage, Row, Title } from "./styles";

type Props = {
  className?: string;
  date?: string;
  duration?: number;
  gameTitle?: string;
  isLoading?: boolean;
  theme?: GameType;
  useGif?: boolean;
};
export const GamesLoading: FunctionComponent<Props> = ({
  className,
  date,
  duration = 1,
  gameTitle,
  isLoading = true,
  theme = GameType.Quick,
  useGif = false,
}) => {
  const string = "loading";

  const getLoadingText = (theme?: GameType) => {
    if (gameTitle) return gameTitle;

    const loadingDisplayMapping: Record<GameType, string> = {
      [GameType.Cryptic]: "The SCMP Cryptic Crossword",
      [GameType.Quick]: "The PostMag Quick Crossword",
      [GameType.WordSearch]: "Word Search",
    };
    return theme ? loadingDisplayMapping[theme] : "Crossword";
  };

  const getLoadingGifSource = (theme: GameType) => {
    if (theme === GameType.WordSearch) {
      return "/icons/word-search-loading.gif";
    }
    return "/icons/crossword-loading.gif";
  };

  return (
    <Container
      {...(!useGif && { $theme: theme })} // If not use gif, apply theme background color
      $visible={isLoading}
      className={className}
    >
      {useGif ? (
        <GifImage $theme={theme} alt="Loading" src={getLoadingGifSource(theme)} />
      ) : (
        <>
          <Content>
            {date && (
              <Title $gameType={theme}>
                {getLoadingText(theme)}
                <br />
                <CrosswordName>{format(new Date(date), "EEEE, d LLLL")}</CrosswordName>
              </Title>
            )}
            <Row $gameType={theme}>
              {[...string].map((letter, index) => (
                <Cell $duration={duration / string.length} $theme={theme} key={index}>
                  {letter}
                </Cell>
              ))}
            </Row>
          </Content>
        </>
      )}
    </Container>
  );
};

GamesLoading.displayName = "GamesLoading";
